import type { EventBusPayload } from "@/modules/event-bus";

import { useTranslation } from "react-i18next";

import { isJobModuleRunningNotificationPayload } from "@/entities/broadcast-notification";
import { useUpdateJobModuleStateQueryData } from "@/entities/job-module";
import { useGetSettingsNotifications } from "@/entities/settings";
import { useAppNotification } from "@/modules/app-notification";
import { useAsyncActions } from "@/modules/async-actions";

import { notifyJobModuleRunning } from "./job-module-action-running.helper";

export const useJobModuleActionRunning = () => {
  const { t } = useTranslation();
  const { notify } = useAppNotification();
  const { updateJobModuleState } = useUpdateJobModuleStateQueryData();
  const { setUpdatedState } = useAsyncActions();
  const { isBroadcastNotificationEnabled } = useGetSettingsNotifications();

  const runAction = (payload: EventBusPayload) => {
    if (!isJobModuleRunningNotificationPayload(payload)) return;
    if (isBroadcastNotificationEnabled(payload.job_module.module_tag)) {
      const title = t("broadcast:jobModuleRunning", {
        moduleName: payload.job_module.module_name,
      });
      notifyJobModuleRunning({ notify, title, payload });
    }

    setUpdatedState("jobmodule", payload.job_module.id);
    updateJobModuleState(payload.job_module.id, "Running");
  };

  return { runAction };
};
